module.exports = __webpack_public_path__ + "static/media/closeApps.a56e805f.svg";